import type { FieldObject } from '@/utils/types';
import type { ComponentType } from 'react';
import z from 'zod';

export type FieldComponentProps<T = any> = {
  object: FieldObject<T>;
  field: string;
  label: string;
};

export type RegistryEntry = {
  component: ComponentType<FieldComponentProps>;
};

export const componentsRegistry = z.registry<RegistryEntry>();

function unwrapZodType<T extends z.ZodType>(schema: T): z.ZodType {
  const meta = schema.meta();
  if (meta && 'hidden' in meta && meta.hidden) {
    // this schema won't be in the registry, so it should stay hidden if we don't unwrap it
    return schema;
  }
  if ('unwrap' in schema && typeof schema.unwrap === 'function') {
    return unwrapZodType(schema.unwrap() as z.ZodType);
  }
  return schema;
}

export function getComponentForSchema<Z extends z.ZodType>(
  schema: Z,
): ComponentType<FieldComponentProps> | null {
  const unwrappedSchema = unwrapZodType(schema);
  const entry = componentsRegistry.get(unwrappedSchema);
  return entry ? (entry.component as ComponentType<FieldComponentProps>) : null;
}
